var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { IconButton as IconButtonBase } from "@irati/ui/src/Button";
export var IconButton = styled(IconButtonBase).attrs({ size: 24 })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 10;\n  background: white;\n  top: 50%;\n  border-radius: 2px;\n  padding: ", ";\n  transform: ", ";\n  left: ", ";\n  right: ", ";\n  box-shadow: ", ";\n"], ["\n  position: absolute;\n  z-index: 10;\n  background: white;\n  top: 50%;\n  border-radius: 2px;\n  padding: ", ";\n  transform: ", ";\n  left: ", ";\n  right: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
}, function (_a) {
    var previousNav = _a.previousNav;
    return previousNav ? "translate3D(-25%,-50%,0)" : "translate3D(25%,-50%,0)";
}, function (_a) {
    var previousNav = _a.previousNav;
    return previousNav ? "0" : "auto";
}, function (_a) {
    var previousNav = _a.previousNav;
    return previousNav ? "auto" : "0";
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.low;
});
var templateObject_1;
